import { GlobalDataContext } from "contexts/GlobalData";
import React, { FC, Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import ReactQuill, {Quill} from "react-quill";
import "react-quill/dist/quill.snow.css";
import { requestAPI } from "utils/api";

import { ImageActions } from '@xeger/quill-image-actions';
import { ImageFormats } from '@xeger/quill-image-formats';

Quill.register('modules/imageActions', ImageActions);
Quill.register('modules/imageFormats', ImageFormats);
// Quill.register(new Parchment.Attributor.Style('float', 'float', { 
// 	whitelist: ['left', 'right', 'center']
// }));
//let Embed = Quill.import('blots/block/embed');
const WHITE_STYLE = ['margin', 'display', 'float'];

const formats = [
	'font',
	'header',
	'bold',
	'italic',
	'underline',
	'strike',
	'blockquote',
	'list',
	'bullet',
	'indent',
	'link',
	'align',
	'color',
	'background',
	'size',
	'h1',
	'image',
	'video',
	'float',
	'width',
	'imagewithstyle'
  ];

  
  

  export default function Editor ({
	rndId,
	contentsId,
	description,
	editorHtmlString,
	setEditorHtmlString,
	handleSubmit
}: any) {
	//const [editorState, setEditorState] = useState(EditorState.createEmpty());
	
	const { 
		initData,
	} = useContext (GlobalDataContext);

	const [htmlString, setHtmlString] = useState(description);
	const quillRef = useRef <any> (null);
	const [imgData, setImgData] = useState<any>(null);
	const [postImg, setPostImg] = useState([]);
	const [uploadedInfo, setUploadedInfo] = useState <any> ({});	
	const [previewImg, setPreviewImg] = useState("");
	const [values, setValues] = useState <any> ("");
	const [uploadFileList, setUploadFileList] = useState <any> ([]);
	console.log("sss", values);
	//const [id, setId] = useState <any> (contentsId);
	const newList: any = [];
	
	
	// if(contentsId === "") {
	// 	return 
	// }

	useEffect(()=>{
		console.log("editorHtmlString >> ", editorHtmlString)
		setValues(editorHtmlString);
	},[editorHtmlString])

	var Size = Quill.import('attributors/style/size');
    Size.whitelist = ['16px', '18px', '20px', '22px', '28px'];
	Quill.register(Size, true);

	const fileId = Number(new Date());
	let fileIndex = 0;

	const setFileInfo = (file: any) => {
		const { name, size: byteSize, type } = file;
		const size = (byteSize / (1024 * 1024)).toFixed(2) + 'mb';
		
		setUploadedInfo({ name, size, type }); // name, size, type 정보를 uploadedInfo에 저장
	};

	const requestTemp = async (imgData: any) => {
			
			
			
			
			const formData = new FormData();
			
			const userId = initData.userInfo._id;
			const file = imgData.name.split('.');
			const fileName = file[0]; 
			const fileExt = file[file.length-1]
			
			const newFileName = `${contentsId}_${rndId}_${fileIndex}.${fileExt}`;
			
			
			newList.push(newFileName);

			//setUploadFileList(newList)
			
			console.log(newList);
			
			

			fileIndex++;
			
			// console.log(id);
			// console.log(newFileName);
			//const fileName = Buffer.from(el.originalname, 'ko-kr').toString('utf8');

        	formData.append("file", imgData, newFileName);

			try {
				
				const res: any = await requestAPI ('FILE', `temp`, formData);

				//const res = await imageApi({ img: file });

				const imgUrl = `${process.env.REACT_APP_SERVER_FILE}/temp/${newFileName}`;
				console.log(imgUrl);
				const quillObj: any = quillRef.current.getEditor(); 
				
				//const range = quillObj.getSelection();
				const range = quillObj.getSelection(true);

				//quillObj.editor.insertEmbed(range.index, 'image', imgUrl);
				console.log("range.index ", range.index)
				
				//quillObj.insertText(range.index, "ㅁㄴㅇㄹ\n");
				quillObj.insertEmbed(range.index, 'image', imgUrl);


				//editor.setSelection(range.index + 2, 0);
			} catch (error) {
				console.log(error);
			}
		
	}
	
	const upload = (e : any) => {
		
		console.log('contentsId2', contentsId)
		
		let fileArr = e.target.files;
		let fileRead: any = new FileReader();

		//setPostImg(Array.from(fileArr));
		//setFileInfo(fileArr[0]);
		const range = quillRef.current.getEditor().getSelection(true);

		fileRead.onload = function(){
			setPreviewImg(fileRead.result);

			requestTemp(fileArr[0]);

		};
		
		fileRead.readAsDataURL(fileArr[0]);

		setImgData(fileArr[0]);	
	};

	const imageHandler = () => {

		console.log('contentsId2', contentsId)
			

		const input: any = document.createElement('input');
		input.setAttribute('type', 'file');
		input.setAttribute('accept', 'image/*');
		input.click();
			
		input.addEventListener('change', upload);
	};
	
	
	const modules = useMemo(
		() => ({
			imageActions: {},
  			imageFormats: {},
		  	toolbar: {
			container: [
				[
					{ header: '1' }, { header: '2' },
					{ 'font': [] }
				],
				[{ size: Size.whitelist }],
				['bold', 'italic', 'underline', 'strike', 'blockquote'],
				[
					{ list: 'ordered' }, { list: 'bullet' }, { align: [] },
					{'indent': '-1'}, {'indent': '+1'}
				],
			  	['video', 'image', 'link'],
			],
			handlers: { 
				image: imageHandler,
			},
		  },
		  clipboard: {
			matchVisual: false,
		  },
		}),
		[],
	);
	
	// useEffect(() => {
	// 	return () => {
			
	
			
	// 	};	
	// }, []);

	


	
	useEffect(() => {
		
	}, [quillRef.current?.lastDeltaChangeSet?.ops]);

	


	const updateTextDescription2 = async (text: any) => {
		//text=text.replaceAll("class=", "className=");
		setValues(text);
		setEditorHtmlString(text);
	  };
  
	const uploadCallback = () => {
	  console.log("이미지 업로드");
	};
  
	

	return (
		<ReactQuill 
			theme="snow"
			ref={quillRef}
			modules={modules}
			formats={formats}
			value={values}
			onChange={updateTextDescription2}
		/>
	);
  };